import { Box, Card, CardHeader, Heading, CardBody, CardFooter, Button, Text, useBreakpointValue } from "@chakra-ui/react";
import { primaryColor, primaryFontSize, secondaryColorTwo, secondaryFontSize } from "../../config";
import { ReactElement } from "react";

export interface CarouselCardBody {
    title: string;
    shortContent: string | ReactElement;
    content: string | ReactElement;
}
export interface CarouselCardDetails_t {
    id: string;
    groupId: string;
    title: string;
    image: string;
    imageAlt: string;
    body: CarouselCardBody;
    footer: string;
    href: string;
    previous?: navigatableDetails_t;
    next?: navigatableDetails_t;
}

export interface navigatableDetails_t {
    href: string;
    title: string;
}

export interface CarouselCardProps_t {
    card: CarouselCardDetails_t;
    imageHeight: string;
    footerButtonHandleClick?: (id: string) => void;
}


export default function CarouselCard({ card, footerButtonHandleClick }: CarouselCardProps_t) {
    return (<Box id={card.id} key={card.id} >
        <Card width={{ base: "100%", md: "30vw" }}
            height={{ base: "30rem", md: "30rem" }}
            minH={{ base: "auto", md: "auto" }}
            minW={{ base: "100%", lg: "20rem" }}
            maxW={{ base: "100%", lg: "30rem" }}
        >
            <CardHeader textAlign={"center"} pb={0}>
                <Heading size='md' color={primaryColor}> {card.title}</Heading>
            </CardHeader>
            <CardBody pt={primaryFontSize} pr={0} pl={0} h="8rem" >
                <Box height={{ base: "10rem" }} width={"full"} overflow={"hidden"}
                    pr={{ base: "0", md: primaryFontSize }}
                    pl={{ base: "0", md: primaryFontSize }}
                    backgroundImage={card.image}
                    backgroundSize={{ base: "8rem", md: "12rem" }}
                    backgroundPosition={"50%"}
                    backgroundRepeat={"no-repeat"}
                >
                </Box>
                <Box display="block" height={"15rem"}>
                    <Box p={"0.5rem"}>
                        <Heading textAlign="center" fontSize={secondaryFontSize} color={primaryColor}>{card.body.title}</Heading>
                        <br />
                        <Box overflow={"scroll"} height={"6rem"} >
                            <Box pr={"0.5rem"} pl={"0.5rem"} justifyContent={"center"} color={secondaryColorTwo} >
                                {card.body.shortContent}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </CardBody>
            <CardFooter justifyContent={"center"} className=" text-right-test">
                {
                    footerButtonHandleClick ?
                        <Button bg={primaryColor} color={"white"} onClick={() => footerButtonHandleClick(card.groupId+"_"+card.id)}
                        className=" text-right-test"    
                        _hover={{
                                backgroundColor: secondaryColorTwo,
                            }}
                        >{card.footer}</Button> : card.footer ?
                        <Button bg={primaryColor} color={"white"} as={"a"} href={card.href}
                        className=" text-right-test"
                            _hover={{
                                backgroundColor: secondaryColorTwo,
                            }}
                        >{card.footer}</Button> : null
                }
            </CardFooter>
        </Card>
    </Box>)
}